// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__U5QHR","right":"styles_right__2VV-1"};